const DEIPledge  = () =>{
return (
  
        <main>
          <section className="banner customrPageSec">
            <div className="container">
              <div className="Pledge-inner">
                <div className="pledge-inner-box customrPageSecHeader">
                  {/*
                          <div class="Pledge-inner-img">
                              <img src="images/pledge/pledge-logo.png" class="img-fluid" alt="">
                          </div>
                          */}
                  <h1 className>VECTRA International</h1>
                  <h4 className>Diversity, Equity, and Inclusion (DEI) Pledge</h4>
                </div>
                <div className="pledge-inner-content customrPageContent">
                  <p>At VECTRA International, we believe that diversity, equity, and inclusion (DEI) are critical to creating a workplace that is respectful, supportive, and productive for all employees. We are committed to creating a culture that values differences and promotes a sense of belonging for everyone. To that end, we pledge to:
                  </p>
                  <ul className="pl-20">
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Foster a culture of respect and inclusivity:</h4>
                      <p className="text">We will create a workplace that is free from discrimination, harassment, and bias, and where everyone feels valued and supported.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Recruit and retain a diverse workforce:</h4>
                      <p className="text">We will actively seek out and hire employees from diverse backgrounds and perspectives, and we will take steps to retain them by creating a welcoming and supportive environment.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Provide training and education:</h4>
                      <p className="text">We will provide ongoing training and education to all employees on DEI topics, including unconscious bias, and cultural competence.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Review and update policies:</h4>
                      <p className="text">We will foster an environment where everyone feels comfortable sharing their thoughts and ideas, and where diversity is celebrated and encouraged.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Partner with diverse suppliers and vendors:</h4>
                      <p className="text">We will seek out and partner with diverse suppliers and vendors to support the growth and development of diverse businesses.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Measure progress:</h4>
                      <p className="text">We will regularly measure and track our progress on DEI goals, and make adjustments as needed to continue to improve.</p>
                    </li>
                  </ul>
                  <p>
                    We recognize that achieving DEI is an ongoing journey, and we are committed to continuously learning and improving. By making this pledge, we are committing to creating a workplace that values diversity, equity, and inclusion, and that is welcoming and supportive of all employees.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
      );
    }
export default DEIPledge;